'use client';
import { useDrawerFooter_unstable } from "@fluentui/react-drawer";
/**
 * Create the state required to render NavDrawerFooter.
 *
 * The returned state can be modified with hooks such as useNavDrawerFooterStyles_unstable,
 * before being passed to renderNavDrawerFooter_unstable.
 *
 * @param props - props from this instance of NavDrawerFooter
 * @param ref - reference to root HTMLDivElement of NavDrawerFooter
 */ export const useNavDrawerFooter_unstable = (props, ref)=>{
    return useDrawerFooter_unstable(props, ref);
};
